import { Directive, Input } from '@angular/core';
import { AgprComponentStyleEnum } from '../../Basic/enums/social-analysis-types.enum';
import { FilterTypeModel } from './abstract-filter-type.model';
import { IncludeExcludeEnum } from '../enums/include-exclude.enum';

@Directive()
export abstract class AbstractFilterTypeComponent {
    readonly agprComponentStyle = AgprComponentStyleEnum;

    readonly includeExcludeEnum = IncludeExcludeEnum;

    @Input() public style: AgprComponentStyleEnum = AgprComponentStyleEnum.social;
    @Input() public id: string;

    filter: FilterTypeModel;
    abstract refresh();
    currentIncludeExcludeChange(): void {
        this.filter.setIncludeExclude(this.filter.currentIncludeExclude);
    }
}
